__turbopack_context__.v({
  "box": "ApoBankPartnerSection-module__DnOsFa__box",
  "boxText": "ApoBankPartnerSection-module__DnOsFa__boxText",
  "boxTitle": "ApoBankPartnerSection-module__DnOsFa__boxTitle",
  "boxes": "ApoBankPartnerSection-module__DnOsFa__boxes",
  "head": "ApoBankPartnerSection-module__DnOsFa__head",
  "inner": "ApoBankPartnerSection-module__DnOsFa__inner",
  "logoBrand": "ApoBankPartnerSection-module__DnOsFa__logoBrand",
  "logoPartner": "ApoBankPartnerSection-module__DnOsFa__logoPartner",
  "logos": "ApoBankPartnerSection-module__DnOsFa__logos",
  "logosX": "ApoBankPartnerSection-module__DnOsFa__logosX",
  "section": "ApoBankPartnerSection-module__DnOsFa__section",
  "text": "ApoBankPartnerSection-module__DnOsFa__text",
  "title": "ApoBankPartnerSection-module__DnOsFa__title",
});
